(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/redbeemedia/assets/javascripts/video-player-container.js') >= 0) return;  svs.modules.push('/components/components/redbeemedia/assets/javascripts/video-player-container.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
var _svs$components$redbe = svs.components.redbee_video_player,
  PlayerEvents = _svs$components$redbe.PlayerEvents,
  VideoPlayerController = _svs$components$redbe.VideoPlayerController;
var Loader = svs.components.ReactLoader.Loader;
var logger = new svs.core.log.Logger('components:redbee-media');
var VideoPlayerContainer = function VideoPlayerContainer(_ref) {
  var assetId = _ref.assetId,
    _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? false : _ref$autoplay,
    remountPlayer = _ref.remountPlayer,
    _ref$businessunit = _ref.businessunit,
    businessunit = _ref$businessunit === void 0 ? 'RacingOnline' : _ref$businessunit,
    footerButton = _ref.footerButton,
    headerButton = _ref.headerButton,
    headerInfo = _ref.headerInfo,
    noTracking = _ref.noTracking,
    onVideoEnded = _ref.onVideoEnded,
    onVideoStarted = _ref.onVideoStarted,
    posterUrl = _ref.posterUrl,
    replay = _ref.replay,
    sessionToken = _ref.sessionToken,
    useLowLatency = _ref.useLowLatency;
  var videoNodeRef = useRef();
  var playerRef = useRef();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    player = _useState2[0],
    setPlayer = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showLoader = _useState4[0],
    setShowLoader = _useState4[1];
  var preferredFormats = function preferredFormats(supportsDash) {
    return supportsDash ? ['dash', 'hls'] : ['hls'];
  };
  useEffect(function () {
    var _svs$components$redbe2;
    var container = videoNodeRef.current;
    if (container.querySelectorAll('.redbee-player-container').length > 0) {
      return;
    }
    var playerOptions = {
      assetId: assetId,
      autoplay: autoplay,
      customer: 'SvenskaSpel',
      disableCast: true,
      exposureBaseUrl: ((_svs$components$redbe2 = svs.components.redbee_video_player.data) === null || _svs$components$redbe2 === void 0 ? void 0 : _svs$components$redbe2.host) || 'https://exposureapi.emp.ebsd.ericsson.net',
      businessUnit: businessunit,
      controls: false,
      disablePictureInPicture: false,
      noTracking: noTracking,
      preferredFormats: preferredFormats(useLowLatency),
      sessionToken: sessionToken,
      poster: posterUrl,
      wrapperElement: videoNodeRef.current
    };
    var _player = new redBeeMedia.RedBeePlayer({
      player: playerOptions,
      skin: {
        disabled: true
      }
    });
    setShowLoader(true);
    _player.once(PlayerEvents.LOADED, function () {
      playerRef.current = _player;
      setShowLoader(false);
      _player.on(PlayerEvents.START, function () {
        if (!noTracking) {
          var assetTitle = _player.getAssetInfo().getTitle();
          var label = assetTitle === 'unspecified' ? assetId : assetTitle;
          svs.components.analytics.trackEvent({
            action: 'Start',
            category: 'Video',
            opt_label: label,
            opt_value: 1
          });
        }
        onVideoStarted && onVideoStarted();
      });
      _player.on(PlayerEvents.ENDED, function () {
        onVideoEnded && onVideoEnded();
      });
      setPlayer(_player);
    });
    _player.on(PlayerEvents.ERROR, function (error) {
      logger.info('Error when playing video:', error);
    });
    _player.load(assetId);
    return function () {
      var _playerRef$current;
      setPlayer(undefined);
      if (playerRef !== null && playerRef !== void 0 && (_playerRef$current = playerRef.current) !== null && _playerRef$current !== void 0 && (_playerRef$current = _playerRef$current.core) !== null && _playerRef$current !== void 0 && _playerRef$current.destroy) {
        playerRef.current.core.destroy();
      }
    };
  }, [assetId]);
  return React.createElement("div", {
    "data-vjs-player": true
  }, React.createElement("div", {
    className: "video-js-redbee vjs-16-9",
    id: "redbee-media-wrapper",
    ref: videoNodeRef
  }, showLoader ? React.createElement("div", {
    className: "redbeemedia-video-loader-wrapper",
    style: {
      height: '100%',
      width: '100%',
      position: 'absolute',
      marginTop: '-56.25%',
      background: 'rgba(0,0,0,0.45)'
    }
  }, React.createElement("div", {
    className: "redbeemedia-video-loader",
    style: {
      marginTop: '23%'
    }
  }, React.createElement(Loader, {
    size: 300
  }))) : null, player ? React.createElement(VideoPlayerController, {
    footerButton: footerButton,
    headerButton: headerButton,
    headerInfo: headerInfo,
    player: player,
    remountPlayer: remountPlayer,
    replay: replay
  }) : null));
};
svs.components.redbee_video_player.VideoPlayerContainer = VideoPlayerContainer;

 })(window);